import React from 'react';
import {
  ThumbsUp,
  MessageCircle,
  Repeat2,
  Eye,
  Bookmark,
  Share2
} from 'lucide-react';
import ActionIcon from './ActionIcon';
import { Content } from '../../types/content';

interface ContentActionsProps {
  content: Content;
  onLike?: () => void;
  onComment?: () => void;
  onRepost?: () => void;
  onBookmark?: () => void;
  onShare?: () => void;
  compact?: boolean;
}

export default function ContentActions({
  content,
  onLike,
  onComment,
  onRepost,
  onBookmark,
  onShare,
  compact = false
}: ContentActionsProps) {
  const size = compact ? 'sm' : 'md';

  const actions = [
    {
      icon: <ThumbsUp />,
      label: 'Like',
      count: content.likes,
      onClick: onLike,
      active: 'likedBy' in content && content.likedBy.includes('current-user'),
      show: true
    },
    {
      icon: <MessageCircle />,
      label: 'Comment',
      onClick: onComment,
      show: true
    },
    {
      icon: <Repeat2 />,
      label: 'Repost',
      count: 'repostCount' in content ? content.repostCount : undefined,
      onClick: onRepost,
      active: 'repostedBy' in content && content.repostedBy.includes('current-user'),
      show: 'repostCount' in content
    },
    {
      icon: <Eye />,
      label: 'Views',
      count: content.views,
      show: !compact
    },
    {
      icon: <Bookmark />,
      label: 'Bookmark',
      onClick: onBookmark,
      show: true
    },
    {
      icon: <Share2 />,
      label: 'Share',
      onClick: onShare,
      show: true
    }
  ];

  const visibleActions = actions.filter(action => action.show);
  const mainActions = visibleActions.slice(0, compact ? 3 : 4);
  const overflowActions = visibleActions.slice(compact ? 3 : 4);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1">
        {mainActions.map((action, index) => (
          <ActionIcon
            key={action.label}
            icon={action.icon}
            label={action.label}
            count={action.count}
            onClick={action.onClick}
            size={size}
            active={action.active}
          />
        ))}
      </div>

      {overflowActions.length > 0 && (
        <div className="flex items-center gap-1">
          {overflowActions.map((action, index) => (
            <ActionIcon
              key={action.label}
              icon={action.icon}
              label={action.label}
              count={action.count}
              onClick={action.onClick}
              size={size}
              active={action.active}
            />
          ))}
        </div>
      )}
    </div>
  );
}